import React, { useContext, useMemo } from "react";
import SelectInput from "common/SelectInput";
import Request from "common/Request";
import BqnContext from "common/BqnContext";
import { bqnIdTarget } from "common/api";
import { loadAndParseInterfaces } from "./api/interfaces";

const filterOnlyAvailable = (list) =>
  list.filter(({ available }) => available === true);

const asLabelAndValue = (list) =>
  list.map(({ name }) => ({ value: name, label: name }));

const notFoundOrWasDeleted = (found) =>
  found === undefined || found.deleted === true;

const findInList = (list, current) =>
  list.find((item) => current.name === item["interface"]);

const notPresent = (current, list) =>
  notFoundOrWasDeleted(findInList(list, current));

const foundAndDeleted = (found) =>
  found !== undefined && found.deleted === true;

const wasDeleted = (current, list) =>
  foundAndDeleted(findInList(list, current));

const notAssigned = (item) => item.id === "0x0";

const isAvailable = (current, present) =>
  notAssigned(current)
    ? notPresent(current, present)
    : wasDeleted(current, present);

const extendWithAvailability = ([all, present]) =>
  all.map((current) => ({
    ...current,
    available: isAvailable(current, present),
  }));

const getUnusedInterfaces = (getItems, bqnId) =>
  Promise.all([loadAndParseInterfaces(bqnId), getItems()])
    .then(extendWithAvailability)
    .then(filterOnlyAvailable)
    .then(asLabelAndValue)
    .then((available) => ({ available }));

const getsNone = () => [];

const invalid = (reason) => {
  throw reason;
};

const SelectAvailableInterfaces = ({
  onChange,
  name = "device",
  label,
  getItems = getsNone,
}) => {
  const { bqnId, clusterStatus } = useContext(BqnContext);
  const bqnIdAsked = bqnIdTarget(clusterStatus?.mode, bqnId);
  const items = getItems();
  // The interfaces are asked for again when the BQN selected changes, and
  // when the interfaces taken already do: a request built while rendering is
  // a different one on every render, and Request waits for each of them.
  const request = useMemo(
    () => getUnusedInterfaces(() => items, bqnIdAsked),
    [bqnIdAsked, JSON.stringify(items)]
  );

  return (
    <Request during={request}>
      {({ available }) =>
        available.length > 0 ? (
          <SelectInput
            name={name}
            label={label}
            onChange={onChange}
            options={available}
            className="input-control align-left"
          />
        ) : (
          invalid("No devices available")
        )
      }
    </Request>
  );
};

export default SelectAvailableInterfaces;
